export default __webpack_public_path__ + "static/media/2.0f09f571.jpg";